import request from '@/utils/request'

// 获取活动配置
export function getLibraryActivityBasics(query) {
  return request({
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getLibraryActivityBasics?ac_key='+query,
      url: '/api/activity/getLibraryActivityBasics?ac_key='+query,
      method: 'get'
  })
}

// 获取
export function getTutorials(query) {
  return request({
      url: '/api/activity/getTutorials?ac_key='+query,
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getTutorials?ac_key='+query,
      method: 'get'
  })
}

// get 请求模板
export function getWorkConfig(query) {
  return request({
      url: '/api/activity/getWorkConfig?ac_key='+query,
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getWorkConfig?ac_key='+query,
      method: 'get'
  })
}

// get 请求模板
export function getCommonList(query) {
  return request({
      url: '/api/activity/getCommonList?ac_key='+query,
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getCommonList?ac_key='+query,
      method: 'get'
  })
}

// get 请求模板
export function getHighList(query) {
  return request({
      url: '/api/activity/getHighList?ac_key='+query,
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getHighList?ac_key='+query,
      method: 'get'
  })
}

// get 请求模板
export function getActivityWork(query) {
  return request({
      url: '/api/activity/getActivityWork?ac_key='+query,
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getActivityWork?ac_key='+query,
      method: 'get'
  })
}

// get 请求模板
export function getWorkList(query) {
  return request({
      url: '/api/activity/getWorkList?ac_key='+query,
      // url: 'http://loc.library-front-api.yiihuu.com/api/activity/getWorkList?ac_key='+query,
      method: 'get'
  })
}

// 获取参加活动审核通过的图书馆列表信息
export function getLibraryList(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/province/get_part_library_list',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 获取图书馆类型名称、省份列表
export function getProList(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/province/get_sign_list',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 选手信息添加、编辑
export function handlePlayer(data) {
  let ackey = getAcKey()
  return request({
    url: '/api/player',
    method: 'post',
    data:  {...data, ac_key: ackey}
  })
}

// 获取报名选手信息
export function getPlayerInfo(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/player',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 获取配置信息
export const getInfo = (params) => request.get('/api/config/get_info', { params })

export function getPage(data) {
  let ackey = getAcKey()
  return request({
    url: '/api/works/page',
    method: 'post',
    data:  {...data, ac_key: ackey}
    // params: query
  })
}

export function getWorksInfo(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/works/get_works_info',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

export function delOption(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/works/del',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

export function addOption(data) {
  let ackey = getAcKey()
  return request({
    url: '/api/works/add',
    method: 'post',
    data:  {...data, ac_key: ackey}
  })
}

export function getUpImgNum(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/config/get_info',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

export function getWorksType(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/works/get_works_type',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 首页---作品展示
export function getWrokShowList(query) {
  console.log(window.location.href)
  let ackey = getAcKey()
  console.log('ackey==============')
  console.log(ackey)
  return request({
    url: '/api/works/show',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 获取省份列表
export function getAllProList(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/province/get_pro_list',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 获取省份列表
export function getConfigInfo(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/config/get_info',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

function getAcKey(){
  let href = window.location.href
  let hrefArr = href.split('/')
  let ackey = hrefArr[hrefArr.length-2]
  return ackey
}

// 获取作品详情
export function getWroksDetail(query) {
  let ackey = getAcKey()
  return request({
    url: '/api/works/get_works_info',
    method: 'get',
    params: {...query, ac_key: ackey}
  })
}

// 添加、取消 点赞
export function workIsLike(data) {
  let ackey = getAcKey()
  return request({
    url: '/api/work/like',
    method: 'post',
    data:  {...data, ac_key: ackey}
  })
}

// 投票
export function workVote(data) {
  let ackey = getAcKey()
  return request({
    url: '/api/work/vote',
    method: 'post',
    data:  {...data, ac_key: ackey}
  })
}

// 活动列表
export const getActivityList = (params) => request.get('/api/activity/list', { params })